// Zavolani PV do Marfeel
export function callPVMarfeel() {
  window.marfeel = window.marfeel || { cmd: [] };
  window.marfeel.cmd.push(['compass', function(compass: { trackNewPage: () => void; }) {
    compass.trackNewPage();
  }]);
}